import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar/navbar'
import PropertyType from '../../components/property-type'
import GridPropertyOne from '../../components/grid-property-one'
import TeamOne from '../../components/team-one'
import ClientOne from '../../components/client-one'
import SellPropertyOne from '../../components/sell-property-one'
import ExplorePropertyOne from '../../components/explore-property-one'
import AppDownload from '../../components/app-download'
import FooterTop from '../../components/footer-top'
import Footer from '../../components/footer'
import FormTwo from '../../components/form-two'
import logo from '../../assets/img/logo.png'

// import bg from '../../assets/img/home-3.jpg'
import bg from '../../assets/img/homepageimage.png'
import { useDispatch } from 'react-redux'
import { openInfoModal } from '../../store/slices/APIResponseSlice'
import { useHooks } from '../../utils/getHooks'
import { contactUs } from '../../services/ApiServices'
import toast from 'react-hot-toast'
import validator from 'validator';

export default function IndexFive() {
    const dispatch = useDispatch();
    const hooks = useHooks();
    const featuredRef: any = useRef(null);

    const openInfo = hooks.getOpenInfoModal
    const userProfileString = localStorage?.getItem('userProfile');
    const userDetail: any = userProfileString ? JSON.parse(userProfileString) : null;
    const [isOpenInfo, setOpenInfo] = useState<boolean>(false);
    const [email, setEmail] = useState<string>("");
    const [isProcessing, setProcessing] = useState<boolean>(false);
    const [isOpenSendMsgModal, setOpenSendMsgModal] = useState<boolean>(false);

    const scrollIfNeeded = () => {
        const shouldScroll = sessionStorage.getItem("scrollToFeatured");

        if (shouldScroll === "true") {
            featuredRef.current?.scrollIntoView({ behavior: "smooth" });
            sessionStorage.removeItem("scrollToFeatured");
        }
    };

    useEffect(() => {
        // Check immediately when component mounts
        scrollIfNeeded();

        // Also check on browser back
        const handlePopState = () => scrollIfNeeded();

        window.addEventListener("popstate", handlePopState);
        return () => window.removeEventListener("popstate", handlePopState);
    }, []);

    const contactUsApiCall = (e: any) => {
        e.preventDefault();
        setProcessing(true);
        const requestBody: any = {
            name: "unknown",
            email: email,
            subject: "marketing",
            message: "marketing"
        }
        contactUs(requestBody).then((res) => {
            console.log("contact us", res);
            // toast.success(res?.message)
            if (res?.validaterror === "1") {
                toast.error(res?.message)
                setProcessing(false)
                return;
            } else {
                setOpenSendMsgModal(true);
                setOpenInfo(false)
                setEmail("")
                setProcessing(false)
            }
        }).catch((err) => {
            console.log("add space error", err);
        })
    }

    useEffect(() => {
        console.log("openInfo", openInfo);

        if (!userDetail && !openInfo) {
            // Remove modalOpened from localStorage on reload when userDetail is null
            // localStorage.removeItem("modalOpened");
            setTimeout(() => {
                dispatch(openInfoModal(true));
                setOpenInfo(true);
            }, 3000)
            // if (!hasModalOpened) {
            //     // If modal hasn't been opened before, show it after 3 seconds
            //     setTimeout(() => {
            //         setOpenInfo(true);
            //         localStorage.setItem("modalOpened", "true");
            //     }, 3000);
            // }
        }
    }, [userDetail])

    return (
        <>
            <Navbar transparent={false} />
            {
                isOpenSendMsgModal &&
                <div className="modal fade show" style={{ display: 'block', backgroundColor: "#0000008a" }}>
                    <div className="modal-dialog modal-dialog-centered login-pop-form" role="document">
                        <div className="modal-content" id="registermodal">
                            <span className="mod-close" onClick={() => setOpenSendMsgModal(!isOpenSendMsgModal)}>
                                <span className="svg-icon text-primary svg-icon-2hx">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                                        <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"></rect>
                                        <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"></rect>
                                    </svg>
                                </span>
                            </span>
                            <div className="modal-body">
                                <h4 className="modal-header-title" style={{ fontSize: 25 }}>Sent Message</h4>
                                <div className="d-flex align-items-center justify-content-center mb-3">
                                    <span>Your message
                                        has been sent successfully. Someone from our team will reply to you within 48
                                        hours</span>
                                </div>
                                <div className="form-group d-flex">
                                    <button type="button" className="btn btn-md btn-primary fw-medium full-width rounded-2" onClick={() => setOpenSendMsgModal(false)}>Ok</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {
                isOpenInfo &&
                <div className="modal fade show" style={{ display: 'block', backgroundColor: "#0000008a" }}>
                    <div className="modal-dialog modal-dialog-centered login-pop-form" role="document">
                        <div className="modal-content" id="registermodal">
                            <span className="mod-close" onClick={() => setOpenInfo(!isOpenInfo)}>
                                <span className="svg-icon text-primary svg-icon-2hx">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                                        <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"></rect>
                                        <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"></rect>
                                    </svg>
                                </span>
                            </span>
                            <div className="modal-body">
                                <h4 className="modal-header-title">Sign Up!</h4>
                                {/* <div className="d-flex align-items-center justify-content-center mb-3">
                                    <img src={logo} height={50} width={"40%"} />
                                </div> */}
                                <div className="login-form">
                                    <form>
                                        <span style={{ fontSize: 18, color: '#000' }}>Don't Miss Out! Get the latest vacant spaces and properties delivered straight to your inbox. Plus, unlock exclusive offers, insider news, and FREE opportunities to advertise your property or vacant space. Enter your email below to stay ahead!</span>

                                        <div className="form-floating mb-4 mt-4">
                                            <input type="email" className="form-control" placeholder="name@example.com" onChange={(e) => setEmail(e.target.value)} value={email} />
                                            <label>Email address</label>
                                        </div>

                                        <div className="form-group">
                                            <button
                                                type="button"
                                                className="btn btn-lg btn-primary fw-medium full-width rounded-2"
                                                onClick={(e) => {
                                                    if (!email) {
                                                        toast.error("Please enter a email address")
                                                        return;
                                                    }
                                                    if (email && !validator.isEmail(email)) {
                                                        toast.error("Please enter a valid email address")
                                                        return;
                                                    }
                                                    contactUsApiCall(e)
                                                }}
                                                disabled={isProcessing}
                                                style={{ opacity: isProcessing ? 0.5 : 1 }}
                                            >
                                                Ok
                                            </button>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }

            <div className="image-cover hero-banner" style={{ backgroundImage: `url(${bg})`, backgroundRepeat: 'no-repeat', backgroundColor: '#eff6ff', height: '20%' }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-9 col-md-11 col-sm-12">
                            <div className="inner-banner-text text-center">
                                <p style={{ color: "#00a94f", fontSize: 22, fontWeight: 500 }}>Global Commercial & Residential Real Estate Marketplace</p>
                                <p className="lead-i">Now search Residential and Multifamily Properties <span className="badge badge-success">New</span></p>
                                <h2><span className="font-normal">Find Your</span> Perfect Space.</h2>
                            </div>
                            <FormTwo />
                        </div>
                    </div>
                </div>
            </div>

            <section>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-6 col-lg-7 col-md-10">
                            <div className="sec-heading text-center">
                                <h2>Choose Property Type</h2>
                                {/* <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores</p> */}
                            </div>
                        </div>
                    </div>
                    <PropertyType />
                </div>
            </section>
            <div className="clearfix"></div>

            {/* <section className="pt-0">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-6 col-lg-7 col-md-10 text-center">
                            <div className="sec-heading center">
                                <h2>Explore Good places</h2>
                                <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores</p>
                            </div>
                        </div>
                    </div>
                    <GridPropertyOne border={true} />
                    <div className="row align-items-center justify-content-center">
                        <div className="col-lg-12 col-md-12 col-sm-12 text-center mt-5">
                            <Link to="/listings-list-with-sidebar" className="btn btn-primary px-md-5 rounded">Browse More Properties</Link>
                        </div>
                    </div>
                </div>
            </section> */}

            {/* <section className="bg-light">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-7 col-md-10 text-center">
                            <div className="sec-heading center">
                                <h2>Explore Property Professionals</h2>
                                <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores</p>
                            </div>
                        </div>
                    </div>
                    <TeamOne />
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 text-center mt-5">
                            <Link to="/listings-list-with-sidebar" className="btn btn-primary px-lg-5 rounded">Explore More Professionals</Link>
                        </div>
                    </div>
                </div>
            </section>
            <div className="clearfix"></div> */}

            <section className='bg-light' id="featured-property" ref={featuredRef}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-7 col-md-10 text-center">
                            <div className="sec-heading center">
                                <h2>Featured Property</h2>
                                {/* <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores</p> */}
                            </div>
                        </div>
                    </div>
                    <SellPropertyOne border={true} />
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 text-center mt-4">
                            <Link to="/list-layout-one" className="btn btn-primary px-lg-5 rounded">Browse More Properties</Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* <section className="gray-bg">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-7 col-md-10 text-center">
                            <div className="sec-heading center">
                                <h2>Good Reviews by Customers</h2>
                                <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores</p>
                            </div>
                        </div>
                    </div>
                    <ClientOne />
                </div>
            </section> */}

            <section>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-7 col-md-10 text-center">
                            <div className="sec-heading center">
                                <h2>Explore Properties in Top Markets</h2>
                            </div>
                        </div>
                    </div>
                    <ExplorePropertyOne />
                </div>
            </section>

            <AppDownload />

            {/* <FooterTop bg="theme-bg" /> */}

            <Footer />
        </>
    )
}
